import {
  DisplayPropertiesTable,
  type DisplayPropertiesTableProps,
} from "../DisplayPropertiesTable";

type DisplayPropertiesTableWithBackgroundProps = Omit<
  DisplayPropertiesTableProps,
  "containerStyles"
>;

export const DisplayPropertiesTableWithBackground = ({
  ...props
}: DisplayPropertiesTableWithBackgroundProps) => {
  return (
    <DisplayPropertiesTable
      containerStyles={{
        backgroundColor: "secondary.contrastText",
        borderRadius: 2,
        padding: 3,
        width: "100%",
      }}
      {...props}
    />
  );
};

export default DisplayPropertiesTableWithBackground;
